import { render } from "./IssueHoupiaoForm.vue?vue&type=template&id=6d2a6f5f&ts=true"
import script from "./IssueHoupiaoForm.vue?vue&type=script&lang=ts"
export * from "./IssueHoupiaoForm.vue?vue&type=script&lang=ts"

import "./IssueHoupiaoForm.vue?vue&type=style&index=0&id=6d2a6f5f&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__